import setWaitingHallUpdate from '%paysera_seat_selection_integration/js/seatings/redux/components/workflow/actions/setWaitingHallUpdate';
import captureException from '%app/js/common/services/captureException';
import { openSnackbar } from '%app/js/common/components/material/Snackbar';
import cartClient from '%evp_ticket_frontend/js/redux/currentCart/service/CartClient';
import buildResponseErrorNotification from '%paysera_seat_selection_integration/js/seatings/redux/service/buildResponseErrorNotification';
import { setCart } from '%evp_ticket_frontend/js/redux/currentCart';

function updateReservation(cartItem) {
    return async (dispatch) => {
        dispatch(setWaitingHallUpdate(true));
        const { order_detail_id, ...rest } = cartItem;
        try {
            const cart = await cartClient.updateReservation({ id: order_detail_id, cartItem: { ...rest } });
            dispatch(setCart(cart));
        } catch (error) {
            dispatch(openSnackbar(buildResponseErrorNotification(error)));
            captureException(error);
        } finally {
            dispatch(setWaitingHallUpdate(false));
        }
    };
}

export default updateReservation;
